"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const projectorContents: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Sewa Proyektor Terdekat: Solusi Instan, Visual Tajam, Harga Bersahabat</h2>
    <p className="mb-4">
      Gak perlu beli mahal, gak harus pusing cari sana-sini. Dengan layanan <strong>sewa proyektor terdekat</strong>, kamu bisa langsung tayangkan presentasi, film, atau acara penting <strong>hari ini juga</strong>. Cukup booking, langsung
      kami kirim & pasang tanpa ribet. Cocok untuk seminar, rapat kantor, pameran, hingga nonton bareng final sepak bola.
    </p>
    <div className="grid md:grid-cols-2 gap-4 mb-6">
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Tipe Proyektor Sesuai Kebutuhan</h3>
        <p className="text-sm">
          Mulai dari proyektor <strong>3000 lumen hingga 10.000 lumen</strong>. Mau untuk ruangan kecil atau panggung outdoor, kami punya. Pilih <strong>Full HD, WXGA, atau 4K</strong>, bahkan tersedia
          <strong>short throw projector</strong> untuk area terbatas.
        </p>
      </div>
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Sewa Sekaligus Paket Lengkap</h3>
        <p className="text-sm"><strong>Paket sewa proyektor</strong> termasuk layar besar, tripod, kabel HDMI/VGA, remote control, bahkan sound system bila dibutuhkan. Semua langsung siap pakai tanpa tambahan biaya tersembunyi.</p>
      </div>
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Gratis Antar & Pasang di Area Kamu</h3>
        <p className="text-sm">Untuk layanan <strong>sewa proyektor terdekat</strong> di area Jakarta, Tangerang, Bandung, Surabaya, Yogyakarta, dan kota besar lainnya, teknisi kami akan kirim, pasang, dan jemput kembali semua gratis.</p>
      </div>
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Visual Tetap Cerah Siang dan Malam</h3>
        <p className="text-sm">
          Mau dipakai siang hari di ruangan terang atau malam hari di lapangan terbuka? Proyektor kami punya <strong>kecerahan tinggi & resolusi tajam</strong>. Support <strong>Full HD & 4K</strong> untuk visual yang impresif.
        </p>
      </div>
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Durasi 1 Hari, 3 Hari, atau 1 Minggu</h3>
        <p className="text-sm">Cuma butuh satu hari? Atau perlu seminggu untuk event pameran? Sewa bisa harian, mingguan, bahkan bulanan. <strong>Fleksibel & bisa diperpanjang</strong> kapan saja.</p>
      </div>
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Harga Sewa Fleksibel & Bisa Nego</h3>
        <p className="text-sm">Mulai dari <strong>Rp150.000/hari</strong> saja. Makin hemat jika kamu sewa bundling dengan layar besar atau speaker. Budget terbatas? Tenang, <strong>harga sewa proyektor bisa nego</strong>!</p>
      </div>
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Pilih Brand Favorit Kamu</h3>
        <p className="text-sm">Kami sediakan berbagai brand ternama: <strong>Epson, BenQ, Panasonic, ViewSonic</strong>. Stabil, terang, dan terbukti andal. Mau tipe tertentu? Konsultasi gratis sebelum sewa.</p>
      </div>
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Teknisi Standby 24 Jam</h3>
        <p className="text-sm">
          Ada kendala saat acara? Proyektor blank atau koneksi error? Hubungi kami kapan saja. Teknisi siap bantu <strong>remote atau on-site</strong> bila urgent. Layanan <strong>sewa proyektor terdekat</strong> yang kamu bisa andalkan.
        </p>
      </div>
    </div>
    <h2 className="text-xl font-bold mb-3">Layanan Menjangkau Berbagai Kota</h2>
    <p className="mb-4">
      Kami melayani <strong>sewa proyektor terdekat</strong> di Jabodetabek, Bandung, Surabaya, Semarang, Yogyakarta, Medan, dan kota besar lainnya di Indonesia. Tak perlu tunggu kiriman jauh² kami lebih dekat dari yang kamu kira.
    </p>
    <h2 className="text-xl font-bold mb-3">Booking Sekarang, Langsung Pakai</h2>
    <p className="mb-4">Klik tombol <strong> Sewa Sekarang </strong> sebelum slot penuh. Jadikan visual acara kamu lebih berkelas tanpa harus beli mahal. Hari ini booking, besok langsung tampil!</p>

    <CTA
      title="Siap Nobar atau Presentasi Bosku?"
      description="🚚 Butuh sewa proyektor terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking proyektor Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20proyektor.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Proyektor"
    />

  </>
);
